module.exports = __webpack_public_path__ + "img/bg.bcdae56d.png";